'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var crypto = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto

var randomByte;
if (!crypto || !crypto.getRandomValues) {
  randomByte = function randomByte(size) {
    var bytes = [];
    for (var i = 0; i < size; i++) {
      bytes.push(Math.floor(Math.random() * 256));
    }
    return bytes;
  };
} else {
  randomByte = function randomByte(size) {
    return crypto.getRandomValues(new Uint8Array(size));
  };
}
module.exports = randomByte;